export default "__VITE_ASSET__DDc7evbp__"